<div class="rfq-product-info__wrapper">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-12">
        <div>
          <span class="font-bold">Other Details</span>
          <p>
            Manage custom product details here. Add labels and values accordingly.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div formArrayName="custom_fields">
          <table class="lum-table lum-table--classic striped">
            <thead>
              <tr>
                <th>Label</th>
                <th>Value</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="
                  let custom of customFieldsControl?.controls;
                  let idx = index
                "
              >
                <tr [formGroupName]="idx">
                  <td>
                    <input type="text" class="lum-input" formControlName="l" />
                  </td>
                  <td>
                    <input type="text" class="lum-input" formControlName="v" />
                  </td>
                  <td class="actions">
                    <ng-container *ngIf="idx === 0; else removeWeight">
                      <button
                        class="lum-button lum-button--small w-20"
                        mat-icon-button
                        (click)="addField()"
                      >
                        <lum-ui-icon
                          icon="add-1"
                          [width]="16"
                          [height]="16"
                          color="#ffffff"
                        ></lum-ui-icon>
                      </button>
                    </ng-container>
                    <ng-template #removeWeight>
                      <button
                        class="lum-button lum-button--small lum-button--secondary w-20"
                        mat-icon-button
                        (click)="removeField(idx)"
                      >
                        <lum-ui-icon
                          icon="minus-circle"
                          [width]="16"
                          [height]="16"
                          color="#3a47af"
                        ></lum-ui-icon>
                      </button>
                    </ng-template>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</div>
